import { APIS, LLM_BASE_URL } from "../../../../../utils/api-factory";

export const getSessionId = () => {
  let sessionId = sessionStorage.getItem("chatSessionIdKey");
  console.log("statrt-session", sessionId);
  if (!sessionId) {
    sessionId = crypto.randomUUID();

    sessionStorage.setItem("chatSessionIdKey", sessionId);
  }
  return sessionId;
};

export const sendChatMessage = async (message, followUpCsvPath) => {
  try {
    const sessionId = getSessionId();
    const payload = {
      message,
      thread_id: sessionId,
    };
    if (followUpCsvPath) {
      payload.follow_up_csv_path = followUpCsvPath;
    }

    const response = await fetch(APIS.CHATBOT_CHAT_API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      let serverMessage = "";
      try {
        const errJson = await response.json();
        serverMessage = errJson?.message || "";
      } catch {
        // ignore json parse errors
      }
      const msg = serverMessage || `HTTP error! status: ${response.status}`;
      throw new Error(msg);
    }

    const data = await response.json();

    if (!data || typeof data.response !== "string") {
      throw new Error("Invalid response format from server");
    }

    return {
      response: data.response,
      sql_query: data.sql_query ?? undefined,
      truncated: data.truncated ?? false,
      download_link: data.download_link ?? null,
    };
  } catch (error) {
    console.error("API Error:", error);
    if (error instanceof TypeError && /fetch|network/i.test(error.message)) {
      throw new Error(
        "Unable to connect to the server. Please check if the backend is running."
      );
    }
    throw error;
  }
};

export const sendCollectionsMessage = async (message, mode) => {
  const sessionId = getSessionId();
  console.log("Session ID send collec:", sessionId);

  const payload = {
    user_id: "SuperUser",
    // session_id: sessionId,
    user_input: message,
    mode: mode,
  };
  console.log("CHAT PAYLOAD:", payload);
  try {
    const response = await fetch(
      APIS.COLLECTION_CHAT_API + `?session_id=${sessionId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    console.log("Response Status:", response.status);

    if (!response.ok) {
      const errText = await response.text().catch(() => "");
      console.error(" Error Body:", errText);
      throw new Error(`Collections API Error: ${response.status}`);
    }
    const data = await response.json();
    console.log("Parsed Response Data:", data);

    const { message: resMessage, sample_rows, sql, query_id, id } = data;
    console.log("semd col queryid", query_id);

    const finalResponse = {
      type: "mixed",
      text: resMessage || null,
      table: null,
      sql: sql || null,
      query_id: query_id ?? id ?? null,
    };

    console.log("fnl res", finalResponse);

    if (Array.isArray(sample_rows) && sample_rows.length > 0) {
      const columns = Object.keys(sample_rows[0]);
      const rows = sample_rows.map((row) => columns.map((col) => row[col]));

      finalResponse.table = {
        columns,
        rows,
        totalCount: data.total_count ?? 0,
        hasMore: data.has_more ?? false,
        csvDownload: data.csv_download_endpoint ?? null,
      };
    }

    return finalResponse;
  } catch (error) {
    console.error("Collections Request Failed:", error);
    throw error;
  }
};

export const downloadCollectionsCSV = async (csvEndpoint) => {
  try {
    const url = `${LLM_BASE_URL}${csvEndpoint}`;

    console.log("FINAL DOWNLOAD URL:", url);

    const response = await fetch(url, { method: "GET" });

    if (!response.ok) {
      throw new Error("CSV download failed");
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = "collections_data.csv";
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Collection CSV Error:", error);
  }
};

export const checkHealth = async () => {
  const sessionId = getSessionId();
  try {
    console.log("healtAPI");
    const response = await fetch(APIS.GET_HEALTH + `?session_id=${sessionId}`, {
      method: "GET",
    });

    console.log("HEALTH STATUS:", response.status);
    const data = await response.json();
    console.log("HEALTH RESPONSE:", data);
    return data;
  } catch (error) {
    console.error("HEALTH API ERROR:", error);
  }
};

export const fetchChatHistory = async (mode) => {
  console.log("FETCH HISTORY PAYLOAD:", {
    thread_id: sessionId,
    mode,
  });
  const sessionId = getSessionId();

  const response = await fetch(APIS.CHAT_HISTORY + `?session_id=${sessionId}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      thread_id: sessionId,
      mode,
    }),
  });

  console.log("HISTORY API STATUS:", response.status);

  const data = await response.json();

  console.log("HISTORY API RESPONSE:", data);

  return data.conversations || [];
};

export const fetchConversationHistory = async ({
  userId,
  mode,
  page = 1,
  limit = 10,
  sessionId,
}) => {
  if (!sessionId) {
    throw new Error("sessionId missing for history API");
  }
  // const sessionId = getSessionId();
  const url =
    `${APIS.CHAT_CONVERSATION}?` +
    new URLSearchParams({
      user_id: userId,
      session_id: sessionId,
      mode,
      page: String(page),
      limit: String(limit),
    }).toString();

  console.log("HISTORY API URL:", url);
  const res = await fetch(url, {
    method: "GET",
  });
  console.log("HISTORY RESULT:", res);

  if (!res.ok) {
    throw new Error("Conversation history error");
  }

  const data = await res.json();
  console.log("conversatin", data);
  return data.conversations || [];
};

export const fetchConversationList = async (userId, mode) => {
  const sessionId = getSessionId();
  const url =
    `${APIS.GET_CONVERSATION_LIST}?` +
    new URLSearchParams({
      session_id: sessionId,
      user_id: userId,
      mode,
    }).toString();

  const res = await fetch(url, {
    method: "GET",
  });

  if (!res.ok) {
    throw new Error("Conversation list error");
  }

  return await res.json();
};

export const sendFeedbackAPI = async ({
  queryId,
  thumbsUp,
  message = "",
  userId = "SuperUser",
}) => {
  try {
    console.log(" QUERY ID RECEIVED IN sendFeedbackAPI:", queryId);
    const sessionId = getSessionId();

    const payload = {
      user_id: userId,
      session_id: sessionId,
      query_id: queryId,
      thumbs_up: thumbsUp,
      message,
    };
    console.log("FEEDBACK PAYLOAD:", payload);
    console.log(" QUERY ID RECEIVED IN sendFeedbackAPI:", queryId);

    const response = await fetch(APIS.SUBMIT_FEEDBACK, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errText = await response.text();
      throw new Error(errText || "Feedback API failed");
    }

    return await response.json();
  } catch (err) {
    console.error("FEEDBACK API ERROR:", err);
    throw err;
  }
};
